import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3b24eb5c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=3b24eb5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b24eb5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/easy_dev/extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b24eb5c')) {
      api.createRecord('3b24eb5c', component.options)
    } else {
      api.reload('3b24eb5c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3b24eb5c&scoped=true&", function () {
      api.rerender('3b24eb5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/workflow/index.vue"
export default component.exports